var req = require("!!/app/node_modules/pug-loader/index.js??ref--13-1!/app/src/linagora.esn.profile/app/show/details/subheader/profile-show-details-subheader.pug");
module.exports = (req['default'] || req).apply(req, [])